module.exports = __webpack_public_path__ + "img/BFS9.762d5143.svg";